<template>
    <div
        class="modal"
        :class="additionalClasses"
        tabindex="-1"
        role="dialog"
        :style="showStyle"
        @keyup.esc="close"
    >
        <transition name="slide-up">
            <div v-if="is_open" class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <slot name="header" :data="extra_data" :close="close">
                            <h5 class="modal-title">
                                <masked-image v-if="icon" class="modal-title-icon" :src="'/img/icons/' + icon"></masked-image>

                                <span v-html="title"></span>
                            </h5>

                            <close-modal @click="forceClose" />
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body" :data="extra_data" />
                    </div>

                    <div class="modal-footer">
                        <slot name="footer" />
                    </div>
                </div>
            </div>
        </transition>

        <div
            class="modal-backdrop fade"
            :class="{ show: is_open }"
            @click="forceClose"
        ></div>
    </div>
</template>

<script>
import CloseModal from './CloseModal'
import MaskedImage from './MaskedImage'

export default {
    components: {
        'close-modal': CloseModal,
        'masked-image': MaskedImage
    },

    props: {
        extraClass: {
            type: String,
            required: false,
        },

        autoOpen: {
            type: Boolean,
            default: false,
        },

        icon: {
            type: String,
            default: '',
        },

        name: {
            type: String,
            default: 'my_modal',
        },

        title: {
            type: String,
            default: '',
        },

        safeClose:{
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            extra_data: null,
            is_open: false,
        }
    },

    mounted() {
        if(this.autoOpen) {
            this.open()
        }

        window.events.$on('showModal', params => {
            if(params.name === this.name) {
                this.extra_data = params.data
                this.open()
            }
        })

        window.events.$on('hideModal', params => {
            if(params.name === this.name) {
                this.extra_data = params.data
                this.close()
            }
        })
    },

    computed: {
        additionalClasses() {
            let open_class = this.is_open ? 'is-open ' : ''
            let extraClass = this.extraClass || ''

            return open_class + extraClass
        },

        showStyle() {
            return this.is_open ? 'display: block;' : ''
        },
    },

    methods: {
        close(value) {
            if(! this.safeClose || this.name == value) {
                this.is_open = false

                document.body.classList.remove('modal-open')
            }
        },

        forceClose() {
            this.is_open = false

            document.body.classList.remove('modal-open')
        },

        open() {
            this.is_open = true

            document.body.classList.add('modal-open')
        },
    },
}
</script>

<style scoped>
    .modal-backdrop {
        z-index: -1;
    }
</style>